import React, { useState } from 'react'
import axios from 'axios'
import { Button, Col, Space, Breadcrumb, Form } from 'antd'
import { getHeaders, errorToast, successToast, usersUrl } from '../../config'
import { toast } from 'react-toastify'
import BasicInput from 'components/Forms/BasicInput'
import SelectInput from 'components/Forms/SelectInput'
import { ADMIN, MANAGER, DELIVERY_GUY } from 'app-constants'

const UserForm = props => {
  const [payload, setPayload] = useState({
    email: '',
    firstName: '',
    lastName: '',
    otherNames: '',
    phoneNumber: '',
    jobTitle: '',
    userType: '',
    branches: []
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleSubmit = event => {
    event.preventDefault()

    setLoading(true)
    axios
      .post(usersUrl + '/create-user', payload, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        // eslint-disable-next-line
        props.history.push('/users')
        successToast(toast, 'New User Added')
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorToast(toast, 'Error adding user, retry.', err, props)
      })
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/users">System Users</Breadcrumb.Item>
            <Breadcrumb.Item>New User</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">Add New User</div>
            <div className="card-body">
              <Form className="p-2rem" layout="vertical">
                <div className="row">
                  <div className="col-md-5">
                    <BasicInput
                      label="First Name"
                      value={payload.firstName}
                      name={'first name'}
                      placeholder="first name"
                      handleChange={handleInputChange('firstName')}
                      required={true}
                    />
                    {serverErrors.firstName &&
                      serverErrors.firstName.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 offset-md-2 offset-sm-0 ">
                    <BasicInput
                      label="Last Name"
                      value={payload.lastName}
                      name={'last name'}
                      placeholder="last name"
                      handleChange={handleInputChange('lastName')}
                      required={true}
                    />
                    {serverErrors.lastName &&
                      serverErrors.lastName.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Phone Number"
                      value={payload.phoneNumber}
                      name={'phone number'}
                      placeholder="phone number"
                      handleChange={handleInputChange('phoneNumber')}
                      required={true}
                    />

                    {serverErrors.phoneNumber &&
                      serverErrors.phoneNumber.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5 offset-md-2 offset-sm-0 ">
                    <BasicInput
                      label="Email"
                      value={payload.email}
                      name={'email'}
                      placeholder="email"
                      handleChange={handleInputChange('email')}
                      required={true}
                    />
                    {serverErrors.email &&
                      serverErrors.email.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Job Title"
                      value={payload.jobTitle}
                      name={'job title'}
                      placeholder="job title"
                      handleChange={handleInputChange('jobTitle')}
                      required={true}
                    />
                    {serverErrors.jobTitle &&
                      serverErrors.jobTitle.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>
                  <div className="col-md-5 offset-md-2 offset-sm-0 ">
                    <SelectInput
                      placeholder="select"
                      label="Choose This User Type"
                      name="user type"
                      value={payload.userType}
                      onChange={handleSelect('userType')}
                      optionList={[
                        { label: 'Admin', value: ADMIN },
                        { label: 'Manager', value: MANAGER },
                        { label: 'Delivery Guy', value: DELIVERY_GUY }
                      ]}
                      required={true}
                    />
                    {serverErrors.userType &&
                      serverErrors.userType.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {serverErrors.nonFieldErrors &&
                    serverErrors.nonFieldErrors.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}

                  <Col md={24}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        marginBottom: '20px'
                      }}
                    >
                      <Space>
                        {/* eslint-disable-next-line */}
                        <Button onClick={() => props.history.goBack()}>
                          Go Back
                        </Button>
                        <Button
                          type="primary"
                          onClick={handleSubmit}
                          loading={loading}
                        >
                          Submit
                        </Button>
                      </Space>
                    </div>
                  </Col>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserForm
